import {useFetchPaymentWays} from '@rocket-ui/lk-api';
import {getVisiblePaymentWays} from './paymentWaysPreview';

const PREVIEW_LIMIT = 3;

export function usePaymentWaysPreview(options?: {expanded?: boolean}) {
	const query = useFetchPaymentWays();
	const all = query.data ?? [];
	const visibleCount = all.filter((way) => way.visible !== false).length;
	const items = getVisiblePaymentWays(all, options?.expanded ? undefined : PREVIEW_LIMIT);

	return {
		items,
		totalCount: visibleCount,
		hasMore: visibleCount > PREVIEW_LIMIT,
		isLoading: query.isLoading,
		isError: query.isError,
		error: query.error,
		isSuccess: query.isSuccess,
	};
}
